import { StyleProp } from "./StyleProp.mjs";
const DefaultSizeStyle = StyleProp.defineEnum("tldraw:size", {
  defaultValue: "m",
  values: ["s", "m", "l", "xl", "s1", "m1", "l1"]
});
export {
  DefaultSizeStyle
};
//# sourceMappingURL=TLSizeStyle.mjs.map
